// src/config/formSteps.js

import questionmark from "assets/images/questionmark.png";
import steptwofooter from "assets/images/steptwofooter.png";
import stepthreefooter from "assets/images/stepthreefooter.png";
import stepfourfooter from "assets/images/stepfourfooter.png";
import stepfivefooter from "assets/images/stepfivefooter.png";
import stepsixfooter from "assets/images/stepsixfooter.png";
import stepsevenfooter from "assets/images/stepsevenfooter.png";
import stepeightfooter from "assets/images/stepeightfooter.png";
import stepninefooter from "assets/images/stepninefooter.png";

export const formSteps = [
  {
    key: "debtCollectorAction",
    heading: "Hi, what is the debt collector doing?",
    type: "radio",
    options: [
      "Sent me a new lawsuit (Summons)",
      "Put a lien on my property (Abstract of Judgment)",
      "Garnishing my paycheck (Wage Garnishment)",
      "Taking money from my bank account (Bank Levy)",
    ],
    required: true,
    footer: { icon: questionmark, class: "questionmark-img" },
  },
  {
    key: "userInfo",
    heading:
      "We can help with that! I'm attorney Adam Fullman, what's your name?",
    type: "text-grid",
    fields: [
      { label: "First Name", type: "text", required: true },
      { label: "Last Name", type: "text", required: true },
      {
        label: "Phone No",
        type: "text",
        required: true,
        placeholder: "Phone",
        validate: (val) => {
          const cleaned = val.replace(/\D/g, ""); // remove non-digits
          return (
            (/^\d{10}$/.test(cleaned) && true) ||
            "Please enter a valid 10-digit phone number"
          );
        },
      },
      {
        label: "Email",
        type: "text",
        required: true,
        validate: (val) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ||
          "Please enter a valid email address",
      },
    ],
    footer: { icon: steptwofooter, class: "questionmark-img" },
  },
  {
    key: "userGoal",
    heading: "What is your goal?",
    type: "radio",
    options: [
      "I need help to Negotiate my debt & settle",
      "I need help to fight this case",
      "I’m not sure yet",
    ],
    required: true,
    footer: { icon: stepthreefooter, class: "questionmark-img" },
  },
  {
    key: "lawsuitDetails",
    heading: "Great! Let’s get to work on that.",
    type: "text-grid",
    fields: [
      {
        label: "State the lawsuit was filed in",
        type: "dropdown",
        options: [
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
        required: true,
      },
      {
        label: "creditor (plaintiff)",
        dynamicOptionsKey: "creditors",
        type: "searchable-dropdown",

        required: true,
      },
    ],
    footer: { icon: stepfourfooter, class: "questionmark-img" },
  },
  {
    key: "creditorType",
    heading: "Tell me more about the type of creditor/plaintiff.",
    type: "radio",
    options: [
      "Individual (not landlord)",
      "Landlord",
      "Credit Card Company / Debt Buyer / Payday Loan / “Signature” Loan",
      "others",
    ],
    required: true,
    footer: { icon: stepfivefooter, class: "questionmark-img" },
  },
  {
    key: "debtAmount",
    heading: "How much does the debt collector claim you owe now?",
    type: "text-grid",
    fields: [
      {
        label: "Amount",
        type: "number",
        required: true,
        validate: (val) => {
          const num = parseFloat(val);
          if (!/^\d+(\.\d{1,2})?$/.test(val))
            return "Amount must be a valid number";
          if (num > 1) return true;
        },
      },
    ],
    footer: { icon: stepsixfooter, class: "questionmark-img" },
  },
  {
    key: "debtType",
    heading: "Is this a personal debt or a business debt?",
    type: "radio",
    options: ["PERSONAL", "Business (LLC, Corp, Trust)"],
    required: true,
    footer: { icon: stepsevenfooter, class: "questionmark-img" },
  },
  {
    key: "additionalInfo",
    heading: "Finally, tell me your side of the story. We're here to help",
    type: "text-area",
    fields: [
      {
        label: "TELL US ANYTHING ELSE WE NEED TO KNOW.",
        type: "textarea",
        required: true,
        validate: (val) =>
          val.trim().length > 10 || "Please enter at least 500 characters",
      },
    ],
    footer: { icon: stepeightfooter, class: "questionmark-img" },
  },
  {
    key: "finalScreen",
    heading: "One sec while we crunch some numbers...",
    footer: { icon: stepninefooter, class: "questionmark-img" },
    type: "lastScreen",
  },
];
